<!-- <ion-header>
  <ion-toolbar>
    <ion-title>Print</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <div>
      <p class="textCenter"><strong>Admin App</strong></p>
      <p class="textCenter">NO:100, Lake view Estate,</p>
      <p class="textCenter">Kundrathur main road, porur</p>
      <p class="textCenter">Tamil nadu, chennai.</p>
      <p><span>Receipt No: {{product_info.name}}</span><span class="floatRight">Date: {{product_info.order_date}}</span></p>
    </div>
  </ion-grid>
</ion-content> -->
<ion-content>
  <div *ngIf="bill_details" class="full-container" id="order">
    <div class="container-bill">
      <!-- <div class="header">
        <p class="invoice">Invoice</p>
      </div> -->
      <div class="brand">
        <img src="/assets/logo2.png" alt="">
        <!-- <p class="title">
          Meatton App
        </p> -->
      </div>
      <!-- <div *ngIf="bill_details.address" class="address-business">
        <!-- <p>Amuthon foods, Periyasamy Layout,Rathinapuri, Coimbatore, India</p>
        <p>Phone:123456789</p> ->
          <p>{{bill_details.address}}</p>
          <p>{{bill_details.city}}</p>
        <p>{{bill_details.business_phone}}</p>
      </div> -->
      <div *ngIf="!bill_details.address && business_info" class="address">
        <p>{{business_info.business_address}} </p>
        <!-- <p *ngIf="business_info.state">{{business_info.state}}</p> -->
        <p>{{business_info.city}} - {{business_info.zip_code}}</p>
        <p>Phone: {{business_info.contact_number}}</p>
        <h5>GST NO: 33ABTFA6471F1Z9</h5>
        </div>
      <!-- <div class="address-customer">
          <p>{{bill_details.address}}</p>
          <p>{{bill_details.city}}</p>
        <p>{{bill_details.business_phone}}</p>
      </div> -->
      <div class="invoice-details">
        <div class="invoice-date">
          <p class="invoice-no">Bill No: {{bill_details.name}}</p>
          <p class="order-date">Date: {{bill_details.order_date | date:'mediumDate'}}</p>
        </div>
        <div class="item-payments">
          <p class="total-items">Token No: {{bill_details.token ? bill_details.token : '-'}}</p>
          <p class="invoice-no">Cashier Name: {{bill_details.shop_user}}</p>
          <!-- <p class="payment-method">Payment Type: {{bill_details.payment_method_name}}</p> -->
          <!-- <p class="payment-method">Payment Type: {{bill_details.payment_method_name}}</p> -->
        </div>
        <!-- <div class="invoice-date">
          <p class="invoice-no">Customer Name: {{bill_details.customer_name}}</p>
          <p class="order-date">Customer Phone No: {{bill_details.phone}}</p>
        </div> -->
        <div class="invoice-date">
          <p class="payment-method">Payment Mode: <span *ngFor="let item of bill_details.payment_entries;let j = index">{{item.mode_of_payment}} <span *ngIf="bill_details.payment_entries.length - 1 > j"> , </span></span></p>
          <!-- <p class="invoice-no">Employee Name: {{bill_details.full_name}}</p> -->
        </div>
      </div>
      <div class="bill-header">
        <div class="header">
          <table>
            <tr class="header-titles">
              <th class="h-item-name">Item Name</th>
              <th class="h-item-qty">Weight</th>
              <th class="h-item-mrp">Qty</th>
              <th class="h-item-price">Rate</th>
              <th class="h-item-amount">Amount</th>
            </tr>

            <!-- <tr class="items-list" *ngFor="let item of bill_details.items"> 
              <td class="item-name-con" colspan="5">{{item.item_name}};<span *ngIf="item.weight">Weight :{{item.weight<1000?item.weight+'g':item.weight/1000+'kg'}};</span>
                <span *ngIf="item.tray_no">Tray No:{{item.tray_no}}</span><span class="description" [innerHtml]="item.attribute_description"></span></td>
              <td colspan="4" class="item-name">Thanks for answer. I also configured with this library . I am informing u shortly to connect with printer. I would like to notify that. I set maxWidth: 375 . But in pop up it shows full screen. Will it ok on printing ? </td>
            </tr> -->
            <tr class="items-list" *ngFor="let item of bill_details.items"> 
              <td class="item-name-con">{{item.item_name}}
                <!-- <span *ngIf="item.weight">Weight: {{item.weight<1000?item.weight+'g':item.weight/1000+'kg'}};</span> -->
                <p class="m0" *ngIf="item.tray_no">Tray No: {{item.tray_no}}</p>
                <p class="description m0" [innerHtml]="item.attribute_description"></p></td>
              <!-- <td class="item-name">Thanks for answer. I also configured with this library . I am informing u shortly to connect with printer. I would like to notify that. I set maxWidth: 375 . But in pop up it shows full screen. Will it ok on printing ? </td> -->
              <td class="item-qty">{{get_weight_k(item.weight)}}</td>
               <td class="item-qty">{{item.quantity}}</td>
              <!-- <td class="item-mrp">{{item.price |currency:db.currency}}</td> -->
              <td class="item-price open_sans__font">{{item.price |currency:db.currency}}</td>
              <td class="item-amount open_sans__font">{{item.amount |currency:db.currency}}</td> </tr>

            <!-- <tr class="items-list-qty" *ngFor="let item of bill_details.items"> 
              <td></td>
              <td class="item-qty">{{item.quantity}}</td>
              <td class="item-mrp">1000</td>
              <td class="item-price">{{item.price |currency:db.currency}}</td>
              <td class="item-amount">{{item.amount |currency:db.currency}}</td>
            </tr> -->
            <tr class="total-item-qty">
              <td class="align-item-right open_sans__font" colspan="6">Sub Total: {{bill_details.order_subtotal |currency:db.currency}}</td>
            </tr>
            <tr class="">
              <!-- <td  class="total-qty" colspan="3">Total Qty :{{calculate_qty(item)}}</td> -->
              <td class="total-qty" colspan="3">Total Qty: {{calculate_qty(bill_details)}}</td>
              <!-- <td *ngIf="is_order"  class="total-qty" colspan="3">Total Qty: {{bill_details.total_calc}}</td> -->
              <td class="align-item-right" colspan="2">Discounts: {{bill_details.discount |currency:db.currency}}</td>
            </tr>

            <tr class="total-item-qty__">
              <td class="total-items" colspan="2">Total Items :{{bill_details.items.length}}</td>
              <td class="open_sans__font align-item-right" colspan="3">Delivery charge: {{bill_details.shipping_charges |currency:db.currency}}</td>
            </tr>

            <!-- <tr>
              <td class="align-item-right" colspan="3">Sub Total :</td>
              <td class="align-item-right pr15">{{bill_details.order_subtotal |currency:db.currency}}</td>
            </tr> -->

            <tr>
              <!-- <td class="align-item-right" colspan="3">Tax :</td> -->
              <td colspan="6" class="open_sans__font align-item-right pr15">GST: {{bill_details.total_tax_amount |currency:db.currency}}</td>
            </tr>

            <tr>
              <td colspan="6" class="open_sans__font align-item-right pr15">Round Off: {{bill_details.round_off_value |currency:db.currency}}</td>
            </tr>

            <tr class="total-amount-qty">
              <td class="total-items open_sans__font" colspan="2">You Have Saved: {{bill_details.discount|currency:db.currency}}</td>
              <td class="align-item-right open_sans__font" colspan="3">Total Amount :{{bill_details.total_amount |currency:db.currency}}</td>
            </tr>

            <!-- <tr>
              <td class="align-item-right" colspan="4">Delivery Charge :</td>
              <td class="align-item-right pr15">{{bill_details.delivery}}</td>
            </tr> -->

          </table>
        </div>
      </div>
      <div class="wish">
        <p>** THANK YOU ! VISIT AGAIN **</p>
      </div>
      <div class="invoice-details bm5">
        <div class="invoice-date">
          <p class="invoice-no">Customer Name: {{bill_details.customer_name}}</p>
          <p class="order-date">Payment Status</p>
        </div>
        <div class="invoice-date">
          <p class="invoice-no">Customer Phone No: {{bill_details.phone}}</p>
          <p class="order-date">{{bill_details.payment_status}}</p>
        </div>
      </div>
    </div>
    <!-- <div class="cus-ph-number">
      <p class="ph-number">Customer Phone No: {{bill_details.phone}}</p>
    </div> -->
    <div class="qr-code">
      <img class="qr-image" src={{db.product_img(bill_details.qrcode)}}>
    </div>
  </div>
</ion-content>
